module.exports = "<div class=\"row\">\r\n  <h3 class=\"page-header-title\">Reports Management </h3>\r\n  <div class=\"horizantal-line\"></div>\r\n</div>\r\n\r\n\r\n\r\n<p-tabView  >\r\n  <p-tabPanel header=\"Restore Publish Reports\" >\r\n  <app-rptstatusmgmt></app-rptstatusmgmt>\r\n  </p-tabPanel>\r\n  <p-tabPanel header=\"Unlock Reports\">\r\n<app-reports [lockedReports]=\"lockedReports\"\r\n  (unlockReport)=\"unlockReport($event)\">\r\n\r\n</app-reports>\r\n</p-tabPanel>\r\n</p-tabView>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/report-management/report-management.component.html
// module id = ./src/app/admin/report-management/report-management.component.html
// module chunks = main